import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor } from './httpInterceptor.service';
import { ConfigService } from '../services/config.service';
import { Subject } from 'rxjs';
import { SharedService } from '../../common/services/sharedService';
@Injectable({
  providedIn: 'root'
})
export class AEMFragmentService {
  constructor(
    private _httpInterceptor: HttpInterceptor,
    public _sharedService: SharedService,
  ) { }
  public getAemDetailsLandingpage(): Observable<any> {
    let bflJourney = this._sharedService.isBFLJourney();
    if (bflJourney) {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.LandingpageAembfl;
      return this._httpInterceptor.GetAem(url);
    } else {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.LandingpageAem;
      return this._httpInterceptor.GetAem(url);
    }
  }
  public getAemDetails(): Observable<any> {
    let bflJourney = this._sharedService.isBFLJourney();
    if (bflJourney) {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.PlanListAembfl;
      return this._httpInterceptor.GetAem(url);
    } else {
      let url = ConfigService.getInstance().getConfigObject().AEMURL.PlanListAem;
      return this._httpInterceptor.GetAem(url);
    }
  }
}
